import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg width="14" height="17" viewBox="0 0 14 17" xmlns="http://www.w3.org/2000/svg" {...this.props}><path d="M4.812 7.548a2.493 2.493 0 0 1 .091 1.644l5.243 3.206a2.5 2.5 0 1 1-.732.724l-4.976-3.043a2.5 2.5 0 1 1-.184-3.36l4.984-3.154a2.5 2.5 0 1 1 .6.802L4.812 7.549z" /></svg>;
  }

}